import React from 'react';
import { QuoteForm } from './QuoteForm';
import { Phone, Mail, Clock, MapPin } from 'lucide-react';
export function ContactCTA() {
  return <section className="py-20 bg-brand-gray-dark relative overflow-hidden" data-id="element-61">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'radial-gradient(#ffffff 1px, transparent 1px)',
      backgroundSize: '30px 30px'
    }} data-id="element-62"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-63">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20" data-id="element-64">
          {/* Info Column */}
          <div className="w-full lg:w-5/12 text-white pt-8" data-id="element-65">
            <h2 className="font-heading font-bold text-3xl md:text-4xl mb-4" data-id="element-66">
              Ready to Get Started?
            </h2>
            <div className="w-20 h-1 bg-brand-blue mb-8 rounded-full" data-id="element-67"></div>
            <p className="font-body text-gray-300 text-lg mb-10 leading-relaxed" data-id="element-68">
              Whether you need a minor repair or a complete exterior overhaul,
              the Moceri team is ready to help. Fill out the form or give us a
              call to schedule your free inspection.
            </p>

            <div className="space-y-8" data-id="element-69">
              <div className="flex items-start gap-4" data-id="element-70">
                <div className="w-12 h-12 rounded-full bg-brand-blue/20 flex items-center justify-center shrink-0" data-id="element-71">
                  <Phone className="text-brand-blue" size={24} data-id="element-72" />
                </div>
                <div data-id="element-73">
                  <h4 className="font-heading font-bold text-lg mb-1" data-id="element-74">
                    Call Us Directly
                  </h4>
                  <a href="tel:5862033701" className="font-body text-xl text-gray-300 hover:text-brand-blue transition-colors" data-id="element-75">
                    (586) 203-3701
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-76">
                <div className="w-12 h-12 rounded-full bg-brand-blue/20 flex items-center justify-center shrink-0" data-id="element-77">
                  <Mail className="text-brand-blue" size={24} data-id="element-78" />
                </div>
                <div data-id="element-79">
                  <h4 className="font-heading font-bold text-lg mb-1" data-id="element-80">
                    Email Us
                  </h4>
                  <a href="mailto:MoceriRS@gmail.com" className="font-body text-lg text-gray-300 hover:text-brand-blue transition-colors" data-id="element-81">
                    MoceriRS@gmail.com
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-82">
                <div className="w-12 h-12 rounded-full bg-brand-blue/20 flex items-center justify-center shrink-0" data-id="element-83">
                  <MapPin className="text-brand-blue" size={24} data-id="element-84" />
                </div>
                <div data-id="element-85">
                  <h4 className="font-heading font-bold text-lg mb-1" data-id="element-86">
                    Location
                  </h4>
                  <p className="font-body text-lg text-gray-300" data-id="element-87">
                    Harrison Township, Michigan
                    <br data-id="element-88" />
                    <span className="text-sm text-gray-400" data-id="element-89">
                      Serving St. Clair, Macomb & Oakland
                    </span>
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-90">
                <div className="w-12 h-12 rounded-full bg-brand-blue/20 flex items-center justify-center shrink-0" data-id="element-91">
                  <Clock className="text-brand-blue" size={24} data-id="element-92" />
                </div>
                <div data-id="element-93">
                  <h4 className="font-heading font-bold text-lg mb-1" data-id="element-94">
                    Business Hours
                  </h4>
                  <p className="font-body text-lg text-gray-300" data-id="element-95">
                    Monday - Saturday: 7:00 AM - 7:00 PM
                    <br data-id="element-96" />
                    Sunday: Closed
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Form Column */}
          <div className="w-full lg:w-7/12" data-id="element-97">
            <QuoteForm data-id="element-98" />
          </div>
        </div>
      </div>
    </section>;
}